/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { AbilityModel } from '../../../models/AbilityModel'
import { revertPriceNumner } from '../../../selectors'
import { useIntl } from 'react-intl'
import { ABILITIES_PAYMENT_METHOD } from '../../../constants/common'
import { NumericFormat } from 'react-number-format'
import { PayrollPaymentModel } from '../../../models/account-books/PayrollAccount'
import { UserModel } from '../../../modules/auth/models/UserModel'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../setup'
import { BankModel } from '../../../models/StoreModel'

type Props = {
    show: boolean
    mode: string
    onClose: () => void
    onSubmit: (values: any, actions: any) => void
}

const SelectBankModal: React.FC<Props> = ({ show, mode, onClose, onSubmit }) => {
    const intl = useIntl();
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const banks = user?.store?.banks
    const defaultBank = banks?.find((bank: BankModel) => {return bank.is_default == 1})
    let initValues: any = {
        bank_id: defaultBank?.id ?? (banks?.[0]?.id ?? undefined)
    };
    return (
        <Modal
            show={show}
            onHide={onClose}
            aria-labelledby='contained-modal-title-vcenter'
            centered
        >
            <Modal.Body className="px-10">
                <Formik initialValues={initValues} onSubmit={onSubmit}>
                    {({ values, handleChange }) => (
                        <Form>
                            <div className="d-flex flex-column  gap-5 pt-3">
                                <div className="fv-row flex-row-fluid fv-plugins-icon-container">
                                    <label className="form-label">Ngân hàng</label>
                                    <Field
                                        as='select'
                                        name='bank_id'
                                        className='form-select'
                                    >
                                        {banks && banks.map((bank: BankModel) => {
                                            return <option value={bank.id}>{bank.bank_account_number} - {bank.bank_name}</option>
                                        })}
                                    </Field>
                                </div>
                            </div>
                            <div className='d-flex mb-4 justify-content-between pt-8'>
                                <button className="btn btn-bg-secondary" type="button" onClick={() => onClose()}>Hủy</button>
                                <button className="btn btn-bg-success" type="submit">Tiếp tục</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default SelectBankModal
